import React from 'react';
import { observer } from 'owa-mobx-react';
import { setNextStyleIsEnabled } from 'owa-acui';
import { getCurrentRibbonTheme } from 'owa-acui-theme/lib/utils/getCurrentRibbonTheme';
import { ThemeProvider } from '@fluentui/react';
import { isFeatureEnabled } from 'owa-feature-flags';
import { ensureAppThemeInitialized } from 'owa-acui-theme';
import { initializeIconColorMap, type IconColorMap } from '../../util/getRibbonIconColor';

/**
 * Encapsulates all theme-related logic for Ribbon, including:
 * - Icon color mapping
 * - Fluent UI v8 theme context
 * - Next Style and Fluent v9 feature flag integration
 * - Theme initialization
 */
export const RibbonTheme: React.FC<{
    children: React.ReactNode;
    iconColorMap: IconColorMap;
}> = observer(({ children, iconColorMap }) => {
    const isFluentV9Enabled = isFeatureEnabled('mon-ribbon-fluent-v9-ribbon');

    ensureAppThemeInitialized();

    // Initial rendering will occur when the ribbon definitions are created, so we
    // need to initialize the icon color map first.
    initializeIconColorMap(iconColorMap);

    if (isFluentV9Enabled) {
        setNextStyleIsEnabled(true);
    }

    //  Using Fluent UI v8's `ThemeProvider` until all of 1JS's Ribbon code is on Fluent UI v9
    return (
        <ThemeProvider
            applyTo="none"
            theme={isFluentV9Enabled ? undefined : getCurrentRibbonTheme()}
        >
            {children}
        </ThemeProvider>
    );
}, 'RibbonTheme');
